<template>
  <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
    <template #trigger>
      <button
        class="button"
        :class="{
          'is-success': t.details.status === 'success',
          'is-warning': t.details.status === 'error',
          'is-dark': t.details.status === 'refunded',
          'is-danger': t.details.status === 'chargeback',
          'is-light-green':
            t.details.status === 'billingPending' ||
            t.details.status === 'chargebackPaid'
        }"
        slot="trigger"
        @click.stop
      >
        {{
          t.details.status === "success"
            ? "Sucesso"
            : t.details.status === "error"
            ? "Erro"
            : t.details.status === "open"
            ? "Aberta"
            : t.details.status === "refunded"
            ? "Estornada"
            : t.details.status === "chargeback"
            ? "Chargeback"
            : t.details.status === "chargebackPaid"
            ? "Chargeback pago"
            : "-"
        }}
      </button>
    </template>

    <b-dropdown-item aria-role="listitem">
      <p>Transação via app</p>
    </b-dropdown-item>

    <b-dropdown-item aria-role="listitem">
      <p><b>Fornecedor:</b> e-Sitef</p>
    </b-dropdown-item>

    <b-dropdown-item
      aria-role="listitem"
      v-if="t.discounts && t.discounts.cashbackUsed"
    >
      <b>(-) Cashback: </b>
      {{ `${payments.currencySymbol}${formatMoney(t.discounts.cashbackUsed)}` }}
      <hr class="hr-cashback-used has-background-elegant-black-3" />
    </b-dropdown-item>

    <b-dropdown-item aria-role="listitem" v-if="t.card">
      <b>Cartão: </b>{{ t.card.description }}
    </b-dropdown-item>

    <b-dropdown-item aria-role="listitem">
      <b>Valor cobrado: </b>
      {{ `${payments.currencySymbol}${formatMoney(t.cart.chargedValue)}` }}
    </b-dropdown-item>

    <div v-if="t && t.details && t.details.status === 'error'">
      <b-dropdown-item aria-role="listitem">
        <b>Retorno: </b>
        {{
          t.esitef &&
          t.esitef.transactionEffectuation &&
          t.esitef.transactionEffectuation.response
            ? t.esitef.transactionEffectuation.response.code
            : "-"
        }}
      </b-dropdown-item>

      <b-dropdown-item aria-role="listitem">
        <b>Descrição: </b>
        {{
          t.esitef &&
          t.esitef.transactionEffectuation &&
          t.esitef.transactionEffectuation.response &&
          t.esitef.transactionEffectuation.response.payment
            ? t.esitef.transactionEffectuation.response.payment
                .authorizer_message
            : "-"
        }}
      </b-dropdown-item>
    </div>

    <b-dropdown-item aria-role="listitem" v-if="t.rewards.cashbackAccumulated">
      <hr class="hr-cashback-accumulated has-background-elegant-black-3" />
      <b>(+) Cashback: </b>
      {{
        `${payments.currencySymbol}${formatMoney(
          t.rewards.cashbackAccumulated.total
        )}`
      }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../../mixins/common";
import { mask } from "../../../mixins/mask";

export default {
  mixins: [common, mask],

  props: ["t"],

  computed: {
    ...mapGetters(["payments"])
  }
};
</script>

<style scoped>
.hr-cashback-used {
  margin-top: 0.5rem;
  margin-bottom: 0;
}
.hr-cashback-accumulated {
  margin-top: 0.3rem;
  margin-bottom: 0.5rem;
}
</style>
